export const ReservationStatus = {
	PD: { id: 0, code: 'PD', name: 'Pendente'},
	RQ: { id: 1, code: 'RQ', name: 'Em solicitação'},
	KK: { id: 2, code: 'KK', name: 'Confirmado'},
	XL: { id: 3, code: 'XL', name: 'Cancelado'}
};



// WEBPACK FOOTER //
// ./src/enums/ReservationStatus.js